module.exports = __webpack_public_path__ + "static/media/img-phone.5582c8ec.png";